import { render, staticRenderFns } from "./USDT-TRC20-BEP20.vue?vue&type=template&id=9fd0e962&scoped=true"
import script from "./USDT-TRC20-BEP20.vue?vue&type=script&lang=js"
export * from "./USDT-TRC20-BEP20.vue?vue&type=script&lang=js"
import style0 from "./USDT-TRC20-BEP20.vue?vue&type=style&index=0&id=9fd0e962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd0e962",
  null
  
)

export default component.exports